import { render, staticRenderFns } from "./Newmembers.vue?vue&type=template&id=c70e337c&scoped=true&"
import script from "./Newmembers.vue?vue&type=script&lang=js&"
export * from "./Newmembers.vue?vue&type=script&lang=js&"
import style0 from "./Newmembers.vue?vue&type=style&index=0&id=c70e337c&scoped=true&lang=css&"
import style1 from "./Newmembers.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70e337c",
  null
  
)

export default component.exports